<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户ID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.userId" placeholder="请输入用户ID">
						</el-input>
					</el-form-item>
					<el-form-item label="登录名" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入登录名">
						</el-input>
					</el-form-item>
					<el-form-item  label="用户手机号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.userPhone" placeholder="请输入用户手机号">
						</el-input>
					</el-form-item>
					<el-form-item  label="充值账号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.rechargeAccount" placeholder="请输入充值账号">
						</el-input>
					</el-form-item>
					<el-form-item  label="充值订单号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.orderCode" placeholder="请输入充值订单号">
						</el-input>
					</el-form-item>

					<el-form-item label="充值类型" class='tiny '>
						<el-select v-model="searchInfo.type" placeholder="请选择" clear>
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="话费慢充" :value="0"></el-option>
							<el-option key="1" label="话费快充" :value="1"></el-option>
							<el-option key="2" label="国网电费" :value="2"></el-option>
							<el-option key="3" label="南网电费" :value="3"></el-option>

							<!-- 还未接通 -->
							<!-- <el-option key="4" label="气费" :value="4"></el-option>
							<el-option key="5" label="水费" :value="5"></el-option> -->
						</el-select>
					</el-form-item>
					
					<el-form-item label="充值状态" class='tiny '>
						<el-select v-model="searchInfo.status" placeholder="请选择" clear>
							<el-option key="-1" label="全部" value=""></el-option>

							<el-option key="0" label="待付款" :value="0"></el-option>
							<el-option key="1" label="待充值" :value="1"></el-option>
							<el-option key="2" label="充值中" :value="2"></el-option>
							<el-option key="3" label="充值完成" :value="3"></el-option>
							<el-option key="4" label="充值失败" :value="4"></el-option>
							<el-option key="9" label="充值取消" :value="9"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="退款状态" class='tiny '>
						<el-select v-model="searchInfo.returnStatus" placeholder="请选择" clear>
							<el-option key="-1" label="全部" value="">全部</el-option>
							
							
							
							
							<el-option key="0" label="未申请" :value="0"></el-option>
							<el-option key="1" label="申请中" :value="1"></el-option>
							<el-option key="2" label="审核通过" :value="2"></el-option>
							<el-option key="3" label="审核驳回" :value="3"></el-option>
					
						</el-select>
					</el-form-item>
					<el-form-item label="支付时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
					<el-form-item label="完成时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timerTwo" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
					<el-form-item label="接单时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timerThree" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
					<el-form-item label="排序" class='tiny '>
						<el-select v-model="searchInfo.orderType" placeholder="请选择" clear>
							<el-option key="0" label="默认" :value="0"></el-option>
							<el-option key="1" label="创建时间升序" :value="1"></el-option>
							<el-option key="2" label="创建时间倒序" :value="2"></el-option>
							<el-option key="3" label="完成时间升序" :value="3"></el-option>
							<el-option key="4" label="完成时间倒序" :value="4"></el-option>
					
						</el-select>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="downloadFile">
								导出
							
							</el-button>
						</template>
					</el-form-item>
					
				</el-form>
			</header>
		</div>
		<div style="margin-left: 20px;margin-bottom: 20px;">
			<span>笔数：{{payList.total}}笔</span>
			<span style="padding-left: 20px;">汇总金额：￥{{ amountSum.totalPrice }}</span>
			<span style="padding-left: 20px;">让利金额：￥{{ amountSum.proportionTotalPrice }}</span>
			<span style="padding-left: 20px;">结算金额：￥{{ amountSum.settlementPrice }}</span>
		</div>
		<el-table :data="payList.list" stripe style="width: 100%;" :header-cell-style="headClass" border
			v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">

			<el-table-column prop="userId" label="用户" align="center" :show-overflow-tooltip="true" width="120">
				<template slot-scope="scope">
					{{ scope.row.userId }}
					<span v-if="scope.row.username">~{{ scope.row.username}}</span>
					<span v-if="scope.row.userPhone">~{{scope.row.userPhone}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="orderCode" label="充值订单号" align="center" width="130" :show-overflow-tooltip="true" >
			</el-table-column>
			<!-- <el-table-column prop="type" label="充值类型" align="center" width="80" :show-overflow-tooltip="true" >
				<template slot-scope="scope">
					<span v-if="scope.row.type==0">话费慢充</span>
					<span v-if="scope.row.type==1">话费快充</span>
					<span v-if="scope.row.type==2">国网电费</span>
					<span v-if="scope.row.type==3">南网电费</span>
					<span v-if="scope.row.type==4">气费</span>
					<span v-if="scope.row.type==5">水费</span>
				</template>
			</el-table-column>
			<el-table-column prop="rechargeAccount" label="充值账号" width="130" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="operators" label="手机号运营商" width="110" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->

			<el-table-column prop="" label="缴费账号" align="center" width="200" :show-overflow-tooltip="true" >
				<template slot-scope="scope">
					<div v-if="scope.row.type==0||scope.row.type==1">
						<span>{{ scope.row.operators }}</span>
						-
						<span>{{ scope.row.rechargeAccount }}</span>
						-
						<span>{{ scope.row.realName }}</span>
					</div>
					<div v-if="scope.row.type==2||scope.row.type==3">
						<span v-if="scope.row.type==2">国网</span>
						<span v-if="scope.row.type==3">南网</span>
						-
						<span>{{ scope.row.rechargeAccount }}</span>
					</div>
					<div v-if="scope.row.type==4||scope.row.type==5||scope.row.type==6||scope.row.type==7">
						<span v-if="scope.row.type==4">中燃</span>
						<span v-if="scope.row.type==5">北燃</span>
						<span v-if="scope.row.type==6">水费</span>
						<span v-if="scope.row.type==7">其他燃气</span>
						-
						<span>{{ scope.row.rechargeAccount }}</span>						
					</div>
				</template>
			</el-table-column>

			<el-table-column prop="totalPrice" label="充值/让利" width="120"  align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					￥{{scope.row.totalPrice}}/￥{{scope.row.proportionTotalPrice}}
				</template>
			</el-table-column>
			

			<el-table-column prop="status" label="充值状态"  width="80" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.status == 0" style="color:#61649f;">待付款</span>
					<span v-if="scope.row.status == 1" style="color:#ff9900;">待充值</span>
					<span v-if="scope.row.status == 2" style="color:#2979ff;">充值中</span>
					<span v-if="scope.row.status == 3" style="color:#19be6b;">充值完成</span>
					<span v-if="scope.row.status == 4" style="color:#fa3534;">充值失败</span>
					<span v-if="scope.row.status == 5" style="color:#fa3534;">用户退款</span>
					<span v-if="scope.row.status == 9" style="color:#999999;">充值取消</span>
				</template>
			</el-table-column>
			
			
			<el-table-column prop="payType" label="支付类型" align="center"  width="180" > 
                <template slot-scope="scope">
					<p v-if="scope.row.payType=='sand_ali_pay'">杉德支付</p>
					<p v-if="scope.row.payType=='integral'">
						<!-- 积分支付 -->
						{{scope.row.integralName}}：<span>{{scope.row.integralNum}}个{{scope.row.integralPrice!=1?'(￥'+scope.row.integralPrice+'/个)':''}}</span>
					</p>
					<p v-if="scope.row.payType=='wx'">
						<!-- 微信支付 -->
						微信：<span>￥{{scope.row.cashNum}}</span>
					</p>
					<p v-if="scope.row.payType=='alipay'">
						<!-- 支付宝支付 -->
						支付宝：<span>￥{{scope.row.cashNum}}</span>
					</p>
					<p v-if="scope.row.payType=='wxplural'">
						<!-- 微信混合支付 -->
						<span v-if="scope.row.cashNum">
							微信：<span>￥{{scope.row.cashNum}}</span>
						</span>
						<span v-if="scope.row.integralNum">
							{{scope.row.integralName}}：<span>{{scope.row.integralNum}}个{{scope.row.integralPrice!=1?'(￥'+scope.row.integralPrice+'/个)':''}}</span>
						</span>
					</p>
					<p v-if="scope.row.payType=='aliplural'">
						<!-- 支付宝混合支付 -->
						<span v-if="scope.row.cashNum">
							支付宝：<span>￥{{scope.row.cashNum}}</span>
						</span>
						<span v-if="scope.row.integralNum">
							{{scope.row.integralName}}：<span>{{scope.row.integralNum}}个{{scope.row.integralPrice!=1?'(￥'+scope.row.integralPrice+'/个)':''}}</span>
						</span>
					</p>
				</template>
            </el-table-column>
			<el-table-column prop="idcard" label="基本信息"  width="160" align="left" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.province">{{ scope.row.province }}{{ scope.row.city }}</div>
					<div v-if="scope.row.type==3">证件号：{{scope.row.idcard}}</div>
					<div v-if="scope.row.type==3">三要素：{{scope.row.idcardType}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="returnStatus" label="退款"  width="120" align="left" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.returnStatus == 0&&scope.row.status!=4" style="color:#61649f;display: flex;align-items: center;width: 100px;justify-content: center;">-</div>
					<div>
						<span v-if="scope.row.returnStatus == 1" style="color:#2979ff;">申请中</span>
						<span v-if="scope.row.returnStatus == 2" style="color:#19be6b;">审核通过</span>
						<span v-if="scope.row.returnStatus == 3" style="color:#fa3534;">审核驳回</span>
					</div>
					<div v-if="scope.row.returnRemark"><el-button  size="small" type="text" @click="look(scope.row.returnRemark,'用户申请退款原因')">查看原因</el-button> </div>
					<div v-if="scope.row.returnTime">{{scope.row.returnTime.split('-')[1]}}-{{scope.row.returnTime.split('-')[2]}}</div>
					<div v-if="scope.row.returnType==1&&(scope.row.returnStatus != 0||scope.row.status==4)">原路退回</div>
					<div v-if="scope.row.returnType==2&&(scope.row.returnStatus != 0||scope.row.status==4)">退Cash</div>
				</template>
			</el-table-column>
			<el-table-column prop="remark" label="原因"  width="100" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text"   v-if="scope.row.remark" @click="look(scope.row.remark,'驳回原因')">查看</el-button>
					
					<div v-else>无</div>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" width="160"  align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="payTime" label="支付时间" width="160"  align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="sendTime" label="接单时间" width="160"  align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="completeTime" label="完成时间" width="160" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="rechargeVoucher" label="查看凭证" align="center"  width="80" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" v-if="scope.row.rechargeVoucher" @click="showContent(scope.row.rechargeVoucher)">查 看
					</el-button>
					<span v-else>无</span>
				</template>
			</el-table-column>
			<el-table-column  label="操作"  fixed="right" align="center" width="120">
				<template slot-scope="scope">

					<el-button size="small" type="text" @click="auditOpen(scope.row, scope.row.status)"
					v-if="scope.row.status == 1 ">接单</el-button>

					<el-button size="small" type="text" @click="auditOpen(scope.row, scope.row.status)"
					v-if="scope.row.status == 2">充值结果</el-button>
					<el-button size="small" v-if="scope.row.returnStatus==1" type="text" @click="auditOpens(scope.row, scope.row.status)"
					>审核</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="payList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper"
			:total="payList.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- 查看 -->
		<el-dialog title="凭证" :visible.sync="showContentDialog" width="700px" :close-on-click-modal="false">
			<div >
				<!-- style="max-height: 500px;overflow-y: scroll;" -->
				<div v-if="contentValueArr.length > 0">
					<img v-for="item in contentValueArr" :key="item" :src="item" style="width: 100%;height:auto;" />
				</div>
				<div v-else>
					<img :src="contentValue" style="width: 100%;height:auto;" />
				</div>
			</div>
		
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">关 闭</el-button>
			</span>
		</el-dialog>
		<el-dialog :title="sbtext" :visible.sync="showresonDialog" width="700px" :close-on-click-modal="false">
			<div >
				{{sbreson}}
				
			</div>
		
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showresonDialog = false">关 闭</el-button>
			</span>
		</el-dialog>
		<!-- 操作 -->
		<el-dialog style="float:rigin" title="充值结果操作" :visible.sync="queryDialogVisible" width="50%"
			:close-on-click-modal="false">
			<div class="app-container" style="text-align: center;" v-if="auditBefore==1">
				<div style="margin-bottom: 40px;font-size:22px;">
					确认接单吗?
				</div>
				
			</div>
			<div class="app-container" style="text-align: center;" v-if="auditBefore==2">
				<el-form size="medium">
					<el-form-item label="用户:" label-width="120px">
						{{czInfo.userId}}~{{czInfo.username}}~{{czInfo.userPhone}}
					</el-form-item>
					<el-form-item label="缴费账号:" label-width="120px">
						{{czInfo.rechargeAccount}}
					</el-form-item>
					<el-form-item label="缴费金额:" label-width="120px">
						￥{{czInfo.totalPrice}}
					</el-form-item>
					<el-form-item label="充值结果:" label-width="120px">
						<el-radio-group v-model="auditStatus" 
						style="margin-top:10px;">
							<el-radio :label="3">充值成功</el-radio>
							<el-radio :label="4">充值失败</el-radio>
						</el-radio-group>
					</el-form-item>
					 
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label-width="120px" label="凭证:"><br />
							<el-upload :action="httpUrl" list-type="picture-card" :limit="1"
							 	:on-preview="handlePictureCardPreview"
								:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" :on-success="onSuccess">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
					</div>
					<el-form-item label="退款方式:" label-width="120px" v-if="auditStatus==4">
						<el-radio-group v-model="returnType" 
						style="margin-top:10px;">
							<el-radio :label="2">退Cash</el-radio>
							<el-radio :label="1">原路退回</el-radio>
						</el-radio-group>
					</el-form-item>
					 
					<el-form-item label="原因:" label-width="120px" >
						<el-input style="width: 100%;" v-model="auditReason" placeholder="请输入原因">
						</el-input>
					</el-form-item>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="topUp" :loading="topUpLoading" v-if="auditBefore==1">确 认</el-button>
				<el-button type="primary" @click="remit" :loading="remitLoading" v-if="auditBefore==2">确 认</el-button>
				<el-button  @click="queryDialogVisible = false">取 消</el-button>
			</div>
		</el-dialog>
		
		<el-dialog style="float:rigin" title="退回申请" :visible.sync="tkDialogVisible" width="50%"
			:close-on-click-modal="false">
			
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<el-form-item label="付款方式:" label-width="120px">
						<el-span>					{{tkinfo.payType=='aliplural'?'支付宝混合支付':tkinfo.payType=='wxplural'?'微信混合支付':tkinfo.payType=='wx'?'微信支付':tkinfo.payType=='alipay'?'支付宝支付':'积分支付'}}</el-span>
						（{{tkinfo.integralName}}）
					</el-form-item>
					<el-form-item label="退款金额:" label-width="120px">
						<el-span>￥{{tkinfo.totalPrice}}</el-span>
					</el-form-item>
					<el-form-item label="退回方式:" label-width="120px">
						<el-span>{{tkinfo.returnType==1?'原路退回':'退Cash'}}</el-span>
					</el-form-item>
					
					<el-form-item label="退款备注:" label-width="120px">
						<el-span>{{tkinfo.returnRemark}}</el-span>
					</el-form-item>
					<el-form-item label="申请结果:" label-width="120px">
						<el-radio-group v-model="auditStatuss" 
						style="margin-top:10px;">
							<el-radio :label="2">通过申请</el-radio>
							<el-radio :label="3">驳回申请</el-radio>
						</el-radio-group>
					</el-form-item>
					 
					
					<el-form-item label="原因:" label-width="120px" v-if="auditStatuss==3">
						<el-input style="width: 100%;" v-model="reasons" placeholder="请输入原因">
						</el-input>
					</el-form-item>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="toUpstatus" :loading="tkDialog" >确 认</el-button>
				<el-button  @click="tkDialogVisible = false">取 消</el-button>
			</div>
		</el-dialog>
		

	</div>
</template>

<script>
	import moment from 'moment'; 

	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('livingPayment');

	
	export default {
		components: {
		},
		data() {
			return {
				httpUrl: urls,
				fileList: [],
				tkDialogVisible:false,
				tkDialog:false,
				tkinfo:{},
				amountSum: {},
				loading: false,
				bhLoading:false,
				payList: {}, //列表
				czInfo:{},
				integralWithdrawal: {},
				queryDialogVisible: false,
				ids: '', //id
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {
					status: '',
					type: '',
					orderType:0
				},
				returnType:2,
				reasons:'',
				contentValue: "",
				showContentDialog: false,
				limtlist1: [],	// 审核
				limtlist2: [], // 复核
				sbtext:'',
				isExamine: false,
				isRecheck: false,
				contentValueArr:[],

				proofImageArr: [],
				showresonDialog:false,
				sbreson:'',
				auditID: '',
				auditBefore: 0,
				auditReason: '',
				auditStatus: 3,
				auditStatuss:2,
				remitLoading: false,
				auditTime: '',

				topUpLoading: false,
			};
		},
		computed: {
			
		},
		methods: {
			handlePictureCardPreview(file) {
				// this.dialogImageUrl = file.url;
				this.contentValueArr = []
				this.contentValue = file.url;
				this.showContentDialog = true
			},
			getAmount(){
				let data={
					type:this.searchInfo.type,
					rechargeAccount:this.searchInfo.rechargeAccount,
					userPhone: this.searchInfo.userPhone,
					username:this.searchInfo.username,
					userId:this.searchInfo.userId,
					status:this.searchInfo.status,
					orderCode: this.searchInfo.orderCode,
					startTime:this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",

					comStartTime: this.searchInfo.timerTwo ? this.searchInfo.timerTwo[0] : "",
					comEndTime: this.searchInfo.timerTwo ? this.searchInfo.timerTwo[1] : "",

					jdStartTime: this.searchInfo.timerThree ? this.searchInfo.timerThree[0] : "",
					jdEndTime: this.searchInfo.timerThree ? this.searchInfo.timerThree[1] : "",
					

				}
				this.$api.livingPaymentSum(data).then(res=>{
					// console.log('汇总数据--',res);
					this.amountSum = res.data
				})
			},
			showloadFile(res) {
				if (!res) {
					return
				}
				const link = document.createElement('a');
				let blob = new Blob([res], {
					type: 'application/vnd.ms-excel'
				});
				link.style.display = 'none';
				link.href = URL.createObjectURL(blob);
				link.setAttribute('download', '缴费记录' + '.xls');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},
			downloadFile() { //导出
				
				this.$api.toExcellive({...this.searchInfo}).then((res) => {
					// console.log(res.data)
					this.showloadFile(res.data)
				})
			},
			auditOpen(it, num){ //充值结果操作弹窗打开
				this.auditBefore = num;
				this.auditReason = '';
				this.auditStatus = 3;
				this.auditTime = '';
				this.czInfo=it
				this.proofImageArr = [];
				this.fileList = [];
				this.auditID = it.id;
				this.queryDialogVisible = true;
			},
			auditOpens(it, num){ //充值结果操作弹窗打开
				this.tkinfo=it
				this.tkDialogVisible = true;
			},
			toUpstatus(){
				this.tkDialog=true
				let data={
					returnStatus:this.auditStatuss,
					remark:this.reasons,
					id:this.tkinfo.id
				}
				this.$api.updateReturnStatus(data).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.tkDialogVisible = false;
						this.findBypayList();
					} else {
						this.$message.error(res.message);
					}
					this.tkDialog = false;
				})
			},
			look(res,text){
					this.showresonDialog=true
					this.sbreson=res
					this.sbtext=text
			},
			topUp(){
				let formattedNow = moment().format('YYYY-MM-DD HH:mm:ss');
				let data={
					id: this.auditID,
					status: 2,
					// sendTime: this.auditTime,
					// rechargeVoucher: this.proofImageArr.join(','),
					// remark: this.auditReason
				}
				this.topUpLoading = true;
				this.$api.livingPaymentAudit(data).then((res) => {
					// console.log('res', res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.queryDialogVisible = false;
						this.findBypayList();
					} else {
						this.$message.error(res.message);
					}
					this.topUpLoading = false;
				})
			},
			remit() {
				let formattedNow = moment().format('YYYY-MM-DD HH:mm:ss');
				if(this.auditStatus==4 && this.auditReason==''){
					this.$message.error('充值失败，原因不能为空');
					return
				}
				let data={
					id: this.auditID,
					status: this.auditStatus,
					// sendTime: this.auditTime || formattedNow,
					rechargeVoucher: this.proofImageArr.join(','),
					remark: this.auditReason,
					returnType:this.returnType
				}
				this.remitLoading = true;
				this.$api.livingPaymentAudit(data).then((res) => {
					// console.log('res', res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.queryDialogVisible = false;
						this.findBypayList();
					} else {
						this.$message.error(res.message);
					}
					this.remitLoading = false;
				})
			},
			handleRemove(file, fileList) {
				//console.log(file, fileList);
				if (file.response) {
					this.proofImageArr.remove(file.response.message);
				}
				this.proofImageArr.remove(file.url);
			},
			
			handlePreview(file) {
				//console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			onSuccess(response, file, fileList) {
				this.proofImageArr.push(response.message);
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.findBypayList()
				this.getAmount()
			},
			showContent(content) {
				// console.log('点击的数据---', content)
				this.contentValue = ''
				this.contentValueArr = []
				this.contentValueArr = content.split(',')
				// console.log('数据---',this.contentValueArr )
				if(content){
					this.showContentDialog = true
					return
				}
				this.$message({
					type: 'error',
					message: '没有凭证图片!'
				});
				
			},
			radioGroupChange(){
				this.proofImageArr = []
			},
			
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.findBypayList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findBypayList()
			},
			findBypayList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					orderType:this.searchInfo.orderType,
					type:this.searchInfo.type,
					rechargeAccount:this.searchInfo.rechargeAccount,
					userPhone: this.searchInfo.userPhone,
					username:this.searchInfo.username,
					userId:this.searchInfo.userId,
					status:this.searchInfo.status,
					returnStatus:this.searchInfo.returnStatus,
					orderCode: this.searchInfo.orderCode,
					startTime:this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
					comStartTime: this.searchInfo.timerTwo ? this.searchInfo.timerTwo[0] : "",
					comEndTime: this.searchInfo.timerTwo ? this.searchInfo.timerTwo[1] : "",
					jdStartTime: this.searchInfo.timerThree ? this.searchInfo.timerThree[0] : "",
					jdEndTime: this.searchInfo.timerThree ? this.searchInfo.timerThree[1] : "",
					
				}
				this.$api.livingPaymentList(data).then((res) => { //提现申请列表
					if (res.state == 'success') {
						// console.log('表格shuju--',res.data.list)
						this.payList = res.data
						this.loading = false
						
					}else{
						this.$message.error(res.message);
					}
				})
			
				
			}
		},
		created() {
			// "可审核会员提交凭证的充值管理员ID"
			this.$api.byKey({key:'SYS_CHECK_RECHARGE'}).then(res=>{
				res=JSON.parse(this.$decrypt(res.data))
				if(res.state == 'success'){
					this.limtlist1 = (res.data.settingValue.split(','))
				}
			})
			// 可复核会员提交凭证的充值管理员ID
			this.$api.byKey({key:'SYS_REVIEW_RECHARGE'}).then(res=>{
				res=JSON.parse(this.$decrypt(res.data))
				if(res.state == 'success'){
					// console.log(res);
					this.limtlist2 = (res.data.settingValue.split(','))
					// console.log(this.limtlist2)
				}
			})
			this.getAmount()
			this.findBypayList();	
			// console.log('2',this.ids,this.username);
	
		},
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.lpc-quill img {
		width: 100px;
		height: 120px;
	}

	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}
</style>
